import { createSlice } from "@reduxjs/toolkit";

const immunizationSlice = createSlice({
    name: "immunizations",
    initialState: {},
    reducers: {
        registerImmunization: (state, action) => {
            const immunization = action.payload;
            if (!immunization?.id) return;

            if (!state[immunization.id]) {
                state[immunization.id] = immunization;
            } else {
                console.warn(
                    `⚠️ Immunization ${immunization.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterImmunizations: (state, action) => {
            action.payload.forEach((immunization) => {
                if (!immunization?.id) return;

                if (!state[immunization.id]) {
                    state[immunization.id] = immunization;
                } else {
                    console.warn(
                        `⚠️ Immunization ${immunization.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerImmunization,
    bulkRegisterImmunizations
} = immunizationSlice.actions;

export default immunizationSlice.reducer;
